<template>
    <div class="contract">
        <div class="content" v-html="data.content"></div>
        <div class="content2" v-show="data.content">
             <p>{{$t('contract.signTime')}}：{{data.sign_date}}</p>

            <p v-if="data.money">{{$t('borrow.borrowMoney')}} (Bằng số/VND)：{{data.money}}</p>
            <p v-if="data.rate">{{$t('borrow.rate')}} (%)：{{data.rate}}</p>
            <p v-if="data.month">{{$t('borrow.month')}}：{{data.month}}</p>
            <p>{{$t('contract.idCard')}}：{{data.id_card_num}}</p>
            <p>{{$t('mobile')}}：{{data.mobile}}</p>

            <p>{{$t('contract.signName')}}：</p>
            <img :src="$ht_ip + data.sign_img_url" alt="">
        </div>
         <div class="content3" v-show="data.content">
             <p>{{$t('seal')}}：</p>
            <img :src="$ht_ip + data.seal" alt="">

        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            data:''
        }
    },
    mounted(){
        this.get_data();
    },
    methods:{
        get_data(){
            this.$get(this.$path.contact,{user_id:this.$route.query.user_id}).then(res=>{
                if(res.success){
                    this.data = res.data;
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.contract{
    .content2{
        float: left;
        width:40%;
        p{
            color: red;
            margin-bottom: .1rem;
            
        }
    }
    .content3{
        width:30%;
       /*  float: right; */
        color: red;
        margin-right:30%;
        img{
            height: 16.6rem;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/borrow/contract.vue